// extracted by mini-css-extract-plugin
export default {"table":"resultTable_table__SHi4d","table__column":"resultTable_table__column__jeLWe","table__row":"resultTable_table__row__rj+px"};